import { PatternComponentType } from '@mrb91002/shared-types'

interface SidebarShadowCardProps {
  variant:
    | PatternComponentType.IMAGE_LEFT_TEXT_RIGHT
    | PatternComponentType.TEXT_LEFT_IMAGE_RIGHT
    | PatternComponentType.MULTI_IMAGE
    | PatternComponentType.TIP
    | PatternComponentType.CAUTION
    | PatternComponentType.IMPORTANT
    | PatternComponentType.TEXT_ONLY
  label: string
  imageCount?: number
  onClick?: () => void
}

export function SidebarShadowCard({ variant, label, imageCount = 1, onClick }: SidebarShadowCardProps) {
  const isImageLeft = variant === PatternComponentType.IMAGE_LEFT_TEXT_RIGHT
  const isMultiImage = variant === PatternComponentType.MULTI_IMAGE
  const isTip =
    variant === PatternComponentType.TIP ||
    variant === PatternComponentType.CAUTION ||
    variant === PatternComponentType.IMPORTANT
  const isTextOnly = variant === PatternComponentType.TEXT_ONLY

  if (isTip) {
    return (
      <div
        style={{
          background: 'rgb(55, 65, 81)',
          borderRadius: 8,
          width: '100%',
          color: '#fff',
          boxShadow: 'none',
          padding: 12,
          marginBottom: 12,
          cursor: 'pointer',
          opacity: 1,
          userSelect: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 8,
        }}
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            onClick?.()
          }
        }}
        role="button"
        tabIndex={0}
        aria-label={`Add ${label}`}
        title={label}
      >
        <div style={{ fontSize: 16 }}>💡</div>
        <div style={{ fontSize: 12, fontWeight: 600, textAlign: 'center', lineHeight: 1.2 }}>
          Tip/Caution/
          <br />
          Important
        </div>
      </div>
    )
  }

  if (isTextOnly) {
    return (
      <div
        style={{
          background: 'rgb(55, 65, 81)',
          borderRadius: 8,
          width: '100%',
          color: '#fff',
          boxShadow: 'none',
          padding: 12,
          marginBottom: 12,
          cursor: 'pointer',
          opacity: 1,
          userSelect: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 8,
        }}
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            onClick?.()
          }
        }}
        role="button"
        tabIndex={0}
        aria-label={`Add ${label}`}
        title={label}
      >
        <div style={{ fontSize: 20 }}>📝</div>
        <div style={{ fontSize: 14, fontWeight: 600 }}>Text Block</div>
      </div>
    )
  }

  if (isMultiImage) {
    return (
      <div
        style={{
          background: 'rgb(55, 65, 81)',
          borderRadius: 8,
          width: '100%',
          color: '#fff',
          boxShadow: 'none',
          padding: 12,
          marginBottom: 12,
          cursor: 'pointer',
          opacity: 1,
          userSelect: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 8,
        }}
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            onClick?.()
          }
        }}
        role="button"
        tabIndex={0}
        aria-label={`Add ${label}`}
        title={label}
      >
        {Array.from({ length: imageCount }, (_, i) => (
          <div
            key={`img-${i}`}
            style={{
              background: 'rgb(75, 85, 99)',
              width: imageCount === 1 ? 48 : 32,
              height: 24,
              borderRadius: 4,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 10,
              fontWeight: 600,
            }}
          >
            Img
          </div>
        ))}
      </div>
    )
  }

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: isImageLeft ? '46px 1fr' : '1fr 46px',
        gap: 10,
        alignItems: 'center',
        background: 'rgb(55, 65, 81)',
        borderRadius: 8,
        width: '100%',
        color: '#fff',
        boxShadow: 'none',
        padding: 12,
        marginBottom: 12,
        cursor: 'pointer',
        opacity: 1,
        userSelect: 'none',
      }}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick?.()
        }
      }}
      role="button"
      tabIndex={0}
      aria-label={`Add ${label}`}
      title={label}
    >
      {isImageLeft && (
        <div
          style={{
            background: 'rgb(75, 85, 99)',
            width: 46,
            height: 38,
            borderRadius: 4,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 600,
            fontSize: 13,
          }}
        >
          Img
        </div>
      )}
      <div>
        <div style={{ background: 'rgb(75, 85, 99)', height: 8, borderRadius: 4, marginBottom: 7, width: '87%' }} />
        <div style={{ background: 'rgb(75, 85, 99)', height: 7, borderRadius: 4, width: '66%' }} />
        <div
          style={{
            background: 'rgb(75, 85, 99)',
            height: 4,
            borderRadius: 4,
            width: '40%',
            margin: '6px auto 0 auto',
          }}
        />
      </div>
      {!isImageLeft && (
        <div
          style={{
            background: 'rgb(75, 85, 99)',
            width: 46,
            height: 38,
            borderRadius: 4,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 600,
            fontSize: 13,
          }}
        >
          Img
        </div>
      )}
    </div>
  )
}

export default SidebarShadowCard
